import React, { ReactNode, useEffect, useMemo, useState } from "react";
import {
	Navigate,
	Outlet,
	Route,
	Routes,
	useLocation,
	useNavigate,
} from "react-router-dom";
import DefaultTemplate from "../components/templates/default/DefaultTemplate";
import { Spin } from "antd";
import ListAccount from "../components/organisms/admin/account/ListAccount";
import LoginCms from "../components/organisms/admin/auth/LoginCms";
import LoginSSO from "../components/organisms/portal/auth/LogigSSO";
import CreateKitchenPage from "../pages/admin/kitchen/CreateKitchenPage";
import ListKitchenPage from "../pages/admin/kitchen/ListKitchenPage";
import EditKichenPage from "../pages/admin/kitchen/EditKichenPage";
import ListMenuPage from "../pages/admin/menu/ListMenuPage";
import CreateMenuPage from "../pages/admin/menu/CreateMenuPage";
import EditMenuPage from "../pages/admin/menu/EditMenuPage";
import ListOderTimePage from "../pages/admin/oder_time/ListOderTimePage";
import CreateRolesPage from "../pages/admin/roles/CreateRolesPage";
import EditRolesPage from "../pages/admin/roles/EditRolesPage";
import ListRolesPage from "../pages/admin/roles/ListRolesPage";
import { routePortal } from "./PortalRoute";
import LayoutUser from "../components/organisms/layout/LayoutUser";
import MealReportPage from "../pages/admin/report/MealReportPage";
import ReportQuestionPage from "../pages/admin/report/ReportQuestionPage";
import ReportQuestionDetailPage from "../pages/admin/report/ReportQuestionDetailPage";
import ListQuestionPage from "../pages/admin/question/ListQuestionPage";
import CreateQuestionPage from "../pages/admin/question/CreateQuestionPage";
import EditQuestionPage from "../pages/admin/question/EditQuestionPage";
import Login from "../pages/portal/auth/Login";
import EditAcccountPage from "../pages/admin/account/EditAcccountPage";
import CreateAccountPage from "../pages/admin/account/CreateAccountPage";
import SurveryReportPage from "../pages/admin/report/SurveryReportPage";
import {
	LOCAL_STORAGE_TOKEN_ADMIN_CMS,
	LOCAL_STORAGE_TOKEN_KEY,
	LOCAL_STORAGE_USER_PHONE_NUMBER,
	TITLE_NAV,
	USER_INFO,
} from "../configs/auth";
import jwt_decode from "jwt-decode";
import { Message, roles } from "../configs/constant";
import { useDispatch, useSelector } from "react-redux";
import { setUsers } from "../components/organisms/admin/auth/slice";
import { RootState } from "./store";
import LoginPage from "../components/organisms/portal/auth/login";
import Callback from "../components/organisms/portal/call-back/Callback";
import AuthCallback from "../components/organisms/portal/call-back/AuthCallback";
import CasCallback from "../components/organisms/portal/call-back/CasCallback";
import notificationHandler from "../components/atoms/Notification";
import ListMenuPageSpecial from "../pages/admin/menu/special/ListMenuPage";
import CreateMenuPageSpecial from "../pages/admin/menu/special/CreateMenuPage";
import EditMenuPageSpecial from "../pages/admin/menu/special/EditMenuPage";
import LoggingOrderPage from "../pages/admin/logging/LoggingOrders";
import LoggingPaymentPage from "../pages/admin/logging/LoggingPayments";
import ChangePasswordPage from "../pages/admin/account/ChangePasswordPage";
import QrcodePage from "../pages/admin/qrcode/QrcodePage";
function App() {
	const navigate = useNavigate();
	const [token, setToken] = useState<any>();
	const [tokenPortal, setTokenPortal] = useState<any>();
	const path = useLocation();
	const dispatch = useDispatch();
	const { auth }: any = useSelector((state: RootState) => state.authAdmin);
	const [localAuth, setLocalAuth] = useState<[]>([]);
	const isPublicCallbackRoute = ["/callback", "/authcallback", "/auth/cas/callback"].includes(
		window.location.pathname.toLowerCase()
	);
	const useName = useMemo(() => {
		// @ts-ignore
		let auth = JSON.parse(localStorage.getItem(USER_INFO));
		return auth ? auth.sub : "";
	}, [localStorage, auth]);
	useEffect(() => {
		if (isPublicCallbackRoute) {
			return;
		}
		let token = localStorage.getItem(LOCAL_STORAGE_TOKEN_ADMIN_CMS) ?? "";
		let token_portal = localStorage.getItem(LOCAL_STORAGE_TOKEN_KEY) ?? "";
		setToken(token);
		setTokenPortal(token_portal);
		if (
			window.location.pathname.startsWith("/admin") ||
			window.location.pathname.startsWith("/login-cms")
		) {
			if (token) {
				dispatch(setUsers(jwt_decode(token)));
				return;
			}
			navigate("/login-cms");
		} else {
			if (token_portal) {
				if (window.location.pathname == "/") {
					navigate("/order-meals");
				} else {
					return;
				}
			} else if (
				!window.location.pathname.startsWith("/login-sso") &&
				!window.location.pathname.startsWith("/login")
			) {
				navigate("/login");
			}
		}
	}, [localStorage, dispatch, path?.pathname]);

	React.useEffect(() => {
		if (isPublicCallbackRoute) {
			return;
		}
		let token = localStorage.getItem(LOCAL_STORAGE_TOKEN_ADMIN_CMS) ?? "";
		let token_portal = localStorage.getItem(LOCAL_STORAGE_TOKEN_KEY) ?? "";
		if (token) {
			const currentTime = Date.now() / 1000;
			if (auth.exp < currentTime) {
				localStorage.removeItem(LOCAL_STORAGE_TOKEN_ADMIN_CMS);
				localStorage.removeItem(USER_INFO);
				localStorage.removeItem(TITLE_NAV);
				navigate("/login-cms");
			}
		} else if (token_portal) {
			try {
				let dataTokenPortal: any = jwt_decode(token_portal);
				const currentTime = Date.now() / 1000;

				if (dataTokenPortal?.exp < currentTime) {
					localStorage.removeItem(LOCAL_STORAGE_TOKEN_KEY);
					localStorage.removeItem(LOCAL_STORAGE_USER_PHONE_NUMBER);
					if (window.location.pathname.startsWith("/login-sso")) {
						navigate("/login-sso");
					} else {
						navigate("/login");
					}
				}
			} catch (err) {
				localStorage.removeItem(LOCAL_STORAGE_TOKEN_KEY);
				localStorage.removeItem(LOCAL_STORAGE_USER_PHONE_NUMBER);
				if (window.location.pathname.startsWith("/login-sso")) {
					navigate("/login-sso");
				} else {
					navigate("/login");
				}
			}
		}
	}, [localStorage, dispatch, path?.pathname]);
	React.useEffect(() => {
		if (isPublicCallbackRoute) {
			return;
		}
		if (window.location.pathname.startsWith("/login-cms")) {
			// @ts-ignore
			const auth = JSON.parse(localStorage.getItem(USER_INFO));
			setLocalAuth(auth?.roles);
			if (!auth?.roles) {
				localStorage.removeItem(LOCAL_STORAGE_TOKEN_ADMIN_CMS);
				navigate("/login-cms");
				return;
			}
			if (auth?.roles.includes("SUPER_ADMIN")) {
				navigate("/admin/listAccount");
				localStorage.setItem(TITLE_NAV, "Quản trị tài khoản");
			} else {
				navigate("/admin/listKitchen");
				localStorage.setItem(TITLE_NAV, "Quản trị bếp ăn");
			}
		} else if (window.location.pathname.startsWith("/login-sso")) {
			let token_portal = localStorage.getItem(LOCAL_STORAGE_TOKEN_KEY) ?? "";
			if (token_portal) {
				navigate("/order-meals");
			}
			navigate(`${window.location.pathname}${window.location.search}`);
		} else if (window.location.pathname.startsWith("/login")) {
			let token_portal = localStorage.getItem(LOCAL_STORAGE_TOKEN_KEY) ?? "";
			if (token_portal) {
				navigate("/order-meals");
			}
			navigate(`${window.location.pathname}${window.location.search}`);
		}
	}, [auth, USER_INFO]);
	React.useEffect(() => {
		if (isPublicCallbackRoute) {
			return;
		}
		// @ts-ignore
		const auth = JSON.parse(localStorage.getItem(USER_INFO));
		setLocalAuth(auth?.roles);
		let token = localStorage.getItem(LOCAL_STORAGE_TOKEN_ADMIN_CMS) ?? "";
		let token_portal = localStorage.getItem(LOCAL_STORAGE_TOKEN_KEY) ?? "";
		if (token && path.pathname === "/login-cms") {
			navigate("/admin/listKitchen");
		} else if (
			token_portal &&
			(path.pathname === "/login" || path.pathname === "/login-sso")
		) {
			navigate("/order-meals");
		}
	}, [localStorage, dispatch, path?.pathname]);

	React.useEffect(() => {
		if (isPublicCallbackRoute) {
			return;
		}
		let token = localStorage.getItem(LOCAL_STORAGE_TOKEN_ADMIN_CMS) ?? "";
		let token_portal = localStorage.getItem(LOCAL_STORAGE_TOKEN_KEY) ?? "";
		if (
			!token &&
			!token_portal &&
			path.pathname !== "/login" &&
			path.pathname !== "/login-sso" &&
			path.pathname !== "/login-cms"
		) {
			localStorage.removeItem(USER_INFO);
			localStorage.removeItem(TITLE_NAV);
			navigate("/login");
		}
	}, [path.pathname]);
	// @ts-ignore
	return (
		<Spin spinning={false}>
			<div className="App">
				<Routes>
					<Route path="callback" element={<Callback />} />
					<Route path="authcallback" element={<AuthCallback />} />
					<Route path="auth/cas/callback" element={<CasCallback />} />

					{!token && <Route path="/login-cms" element={<LoginCms />} />}

					{!tokenPortal && <Route path="/login-sso" element={<LoginSSO />} />}
					{!tokenPortal && <Route path="/login" element={<LoginPage />} />}

					<Route
						path="/admin"
						element={
							<DefaultTemplate useName={useName} localAuth={localAuth}>
								<Outlet />
							</DefaultTemplate>
						}
					>
						<Route path="/admin">
							{
								// @ts-ignore
								localAuth?.includes("SUPER_ADMIN") && (
									<>
										<Route path="listAccount" element={<ListAccount />} />
										<Route
											path="createAccount"
											element={<CreateAccountPage />}
										/>
										<Route
											path="editAccount/:id"
											element={<EditAcccountPage />}
										/>

										<Route path="listRoles" element={<ListRolesPage />} />
										<Route path="createRoles" element={<CreateRolesPage />} />
										<Route path="editRoles/:id" element={<EditRolesPage />} />
									</>
								)
							}
							<Route path="listKitchen" element={<ListKitchenPage />} />
							<Route path="createKitchen" element={<CreateKitchenPage />} />
							<Route path="editKitchen/:id" element={<EditKichenPage />} />

							<Route path="listMenu" element={<ListMenuPage />} />
							<Route path="createMenu" element={<CreateMenuPage />} />
							<Route path="editMenu/:id" element={<EditMenuPage />} />

							<Route path="listOderTime" element={<ListOderTimePage />} />
							<Route path="orderLog" element={<LoggingOrderPage />} />
							<Route path="paymentLog" element={<LoggingPaymentPage />} />
							<Route path="MealReportPage" element={<MealReportPage />} />
							<Route
								path="ReportQuestionPage"
								element={<ReportQuestionPage />}
							/>
							<Route
								path="ReportQuestionDetailPage/:id"
								element={<ReportQuestionDetailPage />}
							/>
							<Route path="SurveryReportPage" element={<SurveryReportPage />} />

							<Route path="listQuestion" element={<ListQuestionPage />} />
							<Route path="createQuestion" element={<CreateQuestionPage />} />
							<Route path="editQuestion/:id" element={<EditQuestionPage />} />

							<Route path="listMenuSpecial" element={<ListMenuPageSpecial />} />
							<Route
								path="createMenuSpecial"
								element={<CreateMenuPageSpecial />}
							/>
							<Route
								path="editMenuSpecial/:id"
								element={<EditMenuPageSpecial />}
							/>
							<Route path="change-password" element={<ChangePasswordPage />} />
							<Route path="create-qrcode" element={<QrcodePage />} />
						</Route>
					</Route>
					<Route
						path="/"
						element={
							<LayoutUser>
								<Outlet />
							</LayoutUser>
						}
					>
						<Route path="/">
							{routePortal.map((route) => (
								<Route
									key={route.id}
									path={route.route}
									element={<route.component />}
								/>
							))}
						</Route>
					</Route>
					<Route
						path="*"
						element={
							<div className="flex center justify-center font-bold">
								{/* 404 NotFound */}
							</div>
						}
					></Route>
				</Routes>
			</div>
		</Spin>
	);
}

export default App;
